import { loadState } from '../reducers/usersReducer';
import { TokenService } from './TokenService';

export default async function LoadUser(user: any, dispatch: Function, _toast?: Function) {
    dispatch(loadState(user));

    const access = user?.accessToken?.token ?? user?.access_token?.token ?? '';
    const refresh = user?.refreshToken?.token ?? '';

    TokenService.setAccessToken(access);
    TokenService.setRefreshToken(refresh);
}
